var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRomanceDrama = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Love-Plant--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Love Plant Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.26 11.22a1 1 0 0 0 0.73 0.31 1 1 0 0 0 0.73 -0.31l4.86 -5.07A3.61 3.61 0 0 0 18.26 2a3.6 3.6 0 0 0 -5.77 -0.93 0.72 0.72 0 0 1 -1 0A3.59 3.59 0 0 0 5.73 2a3.58 3.58 0 0 0 0.66 4.15ZM7.13 2.81a2.31 2.31 0 0 1 1.71 -1.25 0.5 0.5 0 0 1 0.57 0.44 0.49 0.49 0 0 1 -0.41 0.55 1.31 1.31 0 0 0 -1 1.84 0.49 0.49 0 0 1 -0.24 0.66 0.5 0.5 0 0 1 -0.67 -0.24 2.3 2.3 0 0 1 0.04 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.14 11a0.23 0.23 0 0 1 -0.25 0 0.26 0.26 0 0 1 -0.1 -0.24c0.35 -2.17 -2.13 -3 -3.43 -1.32 -1 1.29 -0.4 4.33 -0.09 5.62a0.65 0.65 0 0 0 0.65 0.5c1.33 0 4.42 -0.28 5.4 -1.57 1.3 -1.76 -0.18 -3.93 -2.18 -2.99Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18 11.06c-1.41 -1.86 -4.12 -0.91 -3.71 1.47a0.26 0.26 0 0 1 -0.1 0.24 0.25 0.25 0 0 1 -0.25 0C0.93 11.77 -0.7 14.13 0.72 16c1.06 1.39 4.41 1.66 5.85 1.7a0.71 0.71 0 0 0 0.71 -0.54c0.34 -1.41 0.97 -4.71 -0.1 -6.1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 15.63a0.8 0.8 0 0 0 -0.42 -0.13 0.76 0.76 0 0 0 -0.58 0.27 4.78 4.78 0 0 1 -1.86 1.31 0.23 0.23 0 0 1 -0.24 0 0.25 0.25 0 0 1 -0.11 -0.21v-3.6a0.75 0.75 0 0 0 -0.75 -0.75h-0.5a0.76 0.76 0 0 0 -0.75 0.75v6.19a0.23 0.23 0 0 1 -0.11 0.2 0.24 0.24 0 0 1 -0.23 0 4.74 4.74 0 0 1 -1.87 -1.32 0.74 0.74 0 0 0 -0.57 -0.27 0.83 0.83 0 0 0 -0.43 0.13l-0.41 0.29a0.78 0.78 0 0 0 -0.32 0.51 0.84 0.84 0 0 0 0.17 0.59 6.9 6.9 0 0 0 3.42 2.18 0.5 0.5 0 0 1 0.35 0.48V23a1 1 0 0 0 2 0v-3.32a0.5 0.5 0 0 1 0.36 -0.48 6.91 6.91 0 0 0 3.42 -2.2 0.75 0.75 0 0 0 0.16 -0.58 0.72 0.72 0 0 0 -0.32 -0.51Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRomanceDrama);
export default ForwardRef;